import { z } from "zod";
import type { Amount} from "./amount";
import { amountZodSchema, defaultAmount } from "./amount";

type AvailableQuantity = number | "INFINITE";

const availableQuantityZodSchema: z.ZodSchema<AvailableQuantity> = z
    .number()
    .or(z.literal("INFINITE"));

type Quantity = {
    amount: Amount;
    value: number;
};

const quantityZodSchema: z.ZodSchema<Quantity> = z.object({
    amount: amountZodSchema,
    value: z.number().int().min(0),
});

const defaultQuantity: Quantity = {
    amount: defaultAmount,
    value: 1,
};

const emptyQuantity = (amount = defaultAmount): Quantity => ({
    amount,
    value: 0,
});

export {
    defaultQuantity,
    emptyQuantity,
    quantityZodSchema,
    availableQuantityZodSchema,
};
export type { Quantity, AvailableQuantity };
